export default "__VITE_ASSET__DaFrA5pV__"